import HTARTargetMaintenance from '../pages/HTARTargetMaintenance';
import TargetMaintenancePage from '../pages/TargetMaintenance';

const TargetMaintenanceRoute = {
  public: [],
  auth: [
    {
      name: 'target_maintenance',
      path: '/target-maintenance',
      permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM'],
      component: TargetMaintenancePage,
    },
    {
      name: 'htar-target_maintenance',
      path: '/htar-target-maintenance',
      permissions: ['HTAM', 'NSM-HOSPITAL'],
      component: HTARTargetMaintenance,
    },
  ],
};

export default TargetMaintenanceRoute;
